import { z } from "zod";

export const RetrievalMethod = z.enum([
  "raglight_query",
  "fixture_keyword",
  "manual_link",
]);
export type RetrievalMethod = z.infer<typeof RetrievalMethod>;

export const RetrievedContextSchema = z.object({
  chunkId: z.string().min(1),
  sourceDocumentId: z.string().min(1),
  title: z.string().min(1),
  sourceUrl: z.string().url(),
  rawSha256: z.string().regex(/^[a-f0-9]{64}$/),
  textSha256: z.string().regex(/^[a-f0-9]{64}$/),
  locator: z.object({
    kind: z.enum(["article", "annex", "section", "page", "chunk", "unknown"]),
    label: z.string().min(1),
  }),
  snippet: z.string().min(1),
  rank: z.number().int().positive(),
  score: z.number().min(0).max(1).optional(),
  retrievalMethod: RetrievalMethod,
  retrievedAt: z.string().min(1),
  advisoryLabel: z.literal("retrieved_context_not_legal_source"),
});
export type RetrievedContext = z.infer<typeof RetrievedContextSchema>;

export const RetrievalSearchResponseSchema = z.object({
  query: z.string(),
  results: z.array(RetrievedContextSchema),
  count: z.number().int().nonnegative(),
  disclaimer: z.string().min(1),
});
export type RetrievalSearchResponse = z.infer<typeof RetrievalSearchResponseSchema>;
